import React from 'react';
import { useTranslation } from 'react-i18next';
import { CreditCard, Mail, Building } from 'lucide-react';

const BankInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8 text-gray-900">
            {t('bankInfo.title')}
          </h1>

          <p className="text-center text-lg text-gray-600 mb-12">
            {t('bankInfo.description')}
          </p>

          <div className="bg-white rounded-lg shadow-xl p-8 md:p-12">
            <div className="space-y-8">
              <div className="pb-6 border-b border-gray-200">
                <div className="flex items-start space-x-4">
                  <Building className="text-red-600 flex-shrink-0 mt-1" size={24} />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {t('bankInfo.accountName')}
                    </h3>
                    <p className="text-xl text-gray-700 font-medium">
                      {t('bankInfo.accountNameValue')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="pb-6 border-b border-gray-200">
                <div className="flex items-start space-x-4">
                  <CreditCard className="text-red-600 flex-shrink-0 mt-1" size={24} />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {t('bankInfo.iban')}
                    </h3>
                    <p className="text-2xl text-gray-900 font-mono tracking-wider bg-gray-100 p-4 rounded-md">
                      {t('bankInfo.ibanValue')}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div className="flex items-start space-x-4">
                  <Mail className="text-red-600 flex-shrink-0 mt-1" size={24} />
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">
                      {t('bankInfo.easyAddress')}
                    </h3>
                    <p className="text-xl text-red-600 font-medium">
                      {t('bankInfo.easyAddressValue')}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 p-6 bg-red-50 rounded-lg border-l-4 border-red-600">
              <p className="text-gray-700 leading-relaxed">
                Üyelik aidatları ve bağışlarınız için yukarıdaki banka hesap bilgilerini kullanabilirsiniz. 
                İşleminiz sonrasında lütfen dekontunuzu info@canecorsoturkey.org adresine gönderin.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankInfo;
